"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogActions = exports.StyledDialogContentText = exports.StyledAlert = exports.StyledDialogContent = void 0;
const styles_1 = require("@mui/material/styles");
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
exports.StyledDialogContent = (0, styles_1.styled)(DialogContent_1.default)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    minWidth: "550px"
});
exports.StyledAlert = (0, styles_1.styled)("img")({
    maxWidth: "55px",
    maxHeight: "50px",
    marginBottom: "16px",
});
exports.StyledDialogContentText = (0, styles_1.styled)("div")({
    marginTop: "8px",
});
exports.StyledDialogActions = (0, styles_1.styled)(DialogActions_1.default)(({ theme }) => ({
    padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)} `,
    display: "flex",
    justifyContent: "center",
}));
